import {normalize, schema, denormalize} from 'normalizr';

const permission = new schema.Entity('permissions', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {permissions: [permission]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = permission;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = permission;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default permission;
